import React, { useEffect, useState } from 'react'
import "./attributes.css"
import { formatToRupees, isValidNumeric, valueEmptyNonEmptyHandler } from 'utlis/utils'

const RoomRentDefault = ({ data, selectionHandler }) => {

    console.log("# data::", data)

    const [roomRentLimitListData, setRoomRentLimitListData] = useState([])

    const roomRentLimitDataFormatter = (data) => {
        let result = []
        let metroNonMetroObjSelection = data.values
        let dictObject = Object.keys(metroNonMetroObjSelection)

        for (let i = 0; i < dictObject.length; i++) {
            let eachSelection = dictObject[i].toLowerCase()

            if (eachSelection === "icu") {
                result.push({
                    heading: "ICU",
                    section1: "Percentage of SI per day Limit",
                    section1Value: metroNonMetroObjSelection[eachSelection].percentage ? `${metroNonMetroObjSelection[eachSelection].percentage}%` : "-",
                    section2: "Max Per Day",
                    section2Value: valueEmptyNonEmptyHandler(metroNonMetroObjSelection[eachSelection].max),
                    remarks: metroNonMetroObjSelection[eachSelection].remarks ? metroNonMetroObjSelection[eachSelection].remarks : "-"
                })
            }

            if (eachSelection === "normal") {
                result.push({
                    heading: "Normal Room",
                    section1: "Percentage of SI per day Limit",
                    section1Value: metroNonMetroObjSelection[eachSelection].percentage ? `${metroNonMetroObjSelection[eachSelection].percentage}%` : "-",
                    section2: "Max Per Day",
                    section2Value: valueEmptyNonEmptyHandler(metroNonMetroObjSelection[eachSelection].max),
                    remarks: metroNonMetroObjSelection[eachSelection].remarks ? metroNonMetroObjSelection[eachSelection].remarks : "-"
                })
            }
        }

        setRoomRentLimitListData(result)
    }

    useEffect(() => {
        roomRentLimitDataFormatter(data)
    }, [selectionHandler])

    return (
        <div style={{ display: "flex", gap: "24px", overflow: "scroll", width: "100%"}}>
            {roomRentLimitListData.map((each_obj, objKey) => (
                <>
                    <div className="maternity-card-css" key={objKey}>
                        <div class="spacing-css">
                            <div>
                                <span className="maternity-card-heading-css">
                                    {each_obj.heading}
                                </span>
                            </div>
                            <div className="gold-line-css" />
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginTop: "16px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                {each_obj.section1}
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.section1Value}
                            </span>
                        </div>
        
                        <div style={{ display: "flex", flexDirection: "column", marginTop: "16px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                {each_obj.section2}
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.section2Value}
                            </span>
                        </div>

                        <div style={{ display: "flex", flexDirection: "column", marginTop: "14px", gap: "8px" }}>
                            <span className='maternity-max-limit-heading'>
                                Remarks
                            </span>
                            <span className='maternity-max-limit-value'>
                                {each_obj.remarks}
                            </span>
                        </div>

                    </div>
                </>
            ))}
        </div>
    )

    // return <>done</>
}

export default RoomRentDefault
